import axios from "axios";

let API_URL = "";
if (process.env.NODE_ENV !== "production") {
  API_URL = "http://localhost:5000/api/members/"; // lets us use the backend server in local development
}
else {
  API_URL = "/api/members/";
}

// GET all Members
const getAll = async (token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  const { data } = await axios.get(API_URL, config);
  return data;
};
// GET all Members for a specific group
const getMembers = async (id, token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  const { data } = await axios.get(API_URL + id, config);
  return data;
};

//Edit Member
const editMember = async (id, memberData, token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  const { data } = await axios.put(API_URL + id, memberData, config);
  return data;
};

const editWithdrawal = async (id, memberData, token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  const { data } = await axios.put(API_URL + "withdrawal/" + id, memberData, config);
  return data;
}

const memberService = {
  getAll,
  getMembers,
  editMember,
  editWithdrawal,
};

export default memberService;
